var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUncheckedCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5H19.5V19H20H20.5V5H20ZM19 20V19.5H5V20V20.5H19V20ZM4 19H4.5V5H4H3.5V19H4ZM5 4V4.5H19V4V3.5H5V4ZM4 5H4.5C4.5 4.72386 4.72386 4.5 5 4.5V4V3.5C4.17157 3.5 3.5 4.17157 3.5 5H4ZM5 20V19.5C4.72386 19.5 4.5 19.2761 4.5 19H4H3.5C3.5 19.8284 4.17157 20.5 5 20.5V20ZM20 19H19.5C19.5 19.2761 19.2761 19.5 19 19.5V20V20.5C19.8284 20.5 20.5 19.8284 20.5 19H20ZM20 5H20.5C20.5 4.17157 19.8284 3.5 19 3.5V4V4.5C19.2761 4.5 19.5 4.72386 19.5 5H20Z",
    fill: "#F65E18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedCheckbox);
export default __webpack_public_path__ + "static/media/unchecked-checkbox.9bbfda88b0ca8cce150fd9937931c056.svg";
export { ForwardRef as ReactComponent };